import React, { useCallback, useEffect, useState, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import useRealtimeSync from "../../hooks/useRealtimeSync";
import { lastQuery } from "../../helper/lastQuery";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  TextField,
  Tooltip,
  Typography,
  createSvgIcon,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import Setting from "../../Icon/Setting";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAgentAction,
  GetOrganizationAction,
  GetRoleAction,
} from "../../Redux/action/SettingAction";
import Message from "../../Icon/Message";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate } from "react-router-dom";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { handleExport } from "../ExportFunction/ExportFunction";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import { BulkUploadModal } from "../../component/Modal/BulkUploadModal";
import { toTitleCase } from "../../helper/helper";
import GlobalSearch from "../../component/sidebar/globalSearch";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import {
  EditAgentBlockedStatusService,
  ResetUserPasswordService,
} from "../../Redux/service/SettingService";
import LockResetIcon from "@mui/icons-material/LockReset";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const AgentlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [confirmationactiveopen, setConfirmationActiveOpen] = useState(false);
  const [resetPasswordRow, setResetPasswordRow] = useState(null);
  const [resetPasswordConfirmationOpen, setResetPasswordConfirmationOpen] =
    useState(false);

  const [isFilterOpen, setFilterOpen] = useState(false);
  const [Agentlist, setAgentlist] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [table_load, setTable_load] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [data, setData] = useState([]);
  const [Organizationlist, setOrganizationlist] = useState([]);

  const [Rolelist, setRolelist] = useState([]);

  const [visibleColumns, setVisibleColumns] = useState([]);

  const [BulkModal, setBulkModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openbulk = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleBulkClose = () => {
    setAnchorEl(null);
  };

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    setTable_load(true);
    console.log(page);
    let data = {
      page: page,
      limit: limit,
    };
    reload(data);
    // fetchData(page, pagination.limit);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const handleVisibleColumnsChange = useCallback((visibleColumns) => {
    // Handle the change in visible columns
    setVisibleColumns(visibleColumns);
  }, []);

  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    reload({ page: 1, limit: newLimit });
  };

  const RolelistState = useSelector(
    (state) => state.setting?.role?.data?.roles
  );
  const OrganizationlistState = useSelector(
    (state) => state.setting?.organization?.data
  );
  useEffect(() => {
    dispatch(GetRoleAction());
    dispatch(GetOrganizationAction());
  }, []);

  useEffect(() => {
    // //("role list==>",RolelistState)
    const updated = RolelistState?.filter(
      (role) =>
        role.role === "agent_counsellor" ||
        role.role === "agent_accountant" ||
        role.role === "application_supervisor"
    );
    setRolelist(updated);
    setOrganizationlist(
      OrganizationlistState?.organizations?.map(
        ({ organizationName, ...rest }) => ({
          title: organizationName,
          ...rest,
        })
      )
    );
  }, [RolelistState, OrganizationlistState]);

  const printRole = (role) => {
    console.log(role, "dvwehgfwdfuyweg");
    if (role === "agent_counsellor") return "Counselor";
    if (role === "agent_accountant") return "Accounts";
    if (role === "application_supervisor") return "Application Supervisor";
    if (role === "admin") return "Admin";
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/EditAgent/${params.row.id}`);
        };
        const handleResetPasswordClick = (event) => {
          event.stopPropagation();
          setResetPasswordRow(params.row);
          setResetPasswordConfirmationOpen(true);
        };
        return (
          <>
            <Tooltip title="Edit Agent">
              {" "}
              <IconButton onClick={handleEditActionClick}>
                <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reset password and send it to the registered email">
              <IconButton onClick={handleResetPasswordClick}>
                <LockResetIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    ...(!(window.sessionStorage.getItem("user_role_type") === "agent")
      ? [
        {
          field: "organization",
          headerName: "Organization",
          width: 150,
          renderCell: (params) => {
            return (
              <div
              // style={{
              //   textDecoration: "underline",
              //   textTransform: "lowercase",
              // }}
              >
                {toTitleCase(params.row?.organization?.organizationName) ||
                  "N/A"}
              </div>
            );
          },
        },
      ]
      : []),
    // {
    //   field: "organization",
    //   headerName: "Organization",
    //   width: 150,
    //   renderCell: (params) => {
    //     return (
    //       <div
    //         style={{ textDecoration: "underline", textTransform: "lowercase" }}
    //       >
    //         {params.row?.organization?.organizationName}
    //       </div>
    //     );
    //   },
    // },
    {
      field: "firstName",
      headerName: "Agent Name",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="d-flex">{toTitleCase(params.row.firstName)}</div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 150,
    },
    {
      field: "role",
      headerName: "Role",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="d-flex" style={{ color: ThemeColor.BLUE }}>
            {printRole(params.row?.roles?.role)}
            {/* {params.row?.roles.role?.split("_")?.map((r) => {
              return <div>{toTitleCase(r)} &nbsp;</div>;
            })} */}
            {/* {params.row.roles?.map((data, index) => {
              return (
                <div>
                  {data.title}
                  {index + 1 === params.row.roles?.length ? "" : ", "}
                </div>
              );
            })} */}
          </div>
        );
      },
    },
    {
      field: "end_date",
      headerName: "Entry Date",
      width: 150,
      renderCell: (params) => {
        return (
          <div>{dayjs(params.row.createdOn).format("YYYY-MM-DD HH:MM")}</div>
        );
      },
    },

    {
      field: "isActive",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            {params.row?.isActive === "Y" ? "Active" : "In-active"}
          </div>
        );
      },
    },

    {
      field: "blocked",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleBlockingStatusChange = async (e) => {
          console.log(e.target.checked);
          setAgentlist((prev) =>
            prev.map((data) =>
              data.id === params.row.id
                ? { ...data, isBlocked: data.isBlocked === "Y" ? "N" : "Y" }
                : data
            )
          );
          setConfirmationOpen(true);
          setChangeBlockStatusOfOrg({
            id: params.row.id,
            isBlocked: e.target.checked ? "Y" : "N",
          });
        };
        return (
          <>
            {(window.sessionStorage.getItem("user_role_type") === "admin" ||
              window.sessionStorage.getItem("user_role_type") === "user" ||
              (window.sessionStorage.getItem("user_role_type") === "agent" &&
                (window.sessionStorage.getItem("role") === "admin" ||
                  "application_supervisor"))) && (
                <Tooltip title="Restricts full access — the account will no longer appear on the portal.">
                  {" "}
                  <Box display="flex" alignItems="center" className="px-2">
                    <Typography>Blocked</Typography>
                    <Switch
                      sx={{
                        "& .MuiSwitch-track": {
                          // backgroundColor: isToggled ? "white" : "#ccc",
                          transition: "background-color 0.3s",
                          borderRadius: 20,
                        },
                        "& .MuiSwitch-thumb": {
                          width: 24,
                          height: 24,
                          backgroundColor:
                            params.row.isBlocked === "Y"
                              ? ThemeColor.PURPLE
                              : ThemeColor.BLACK,
                          transition: "transform 0.3s ease",
                          transform:
                            params.row.isBlocked === "Y"
                              ? "translateX(2px)"
                              : "translateX(0px)",
                        },
                        "& .MuiSwitch-switchBase": {
                          padding: 1,
                          transition: "transform 0.3s",
                          "&.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: ThemeColor.LIGHTPURPLE,
                          },
                        },
                      }}
                      checked={params.row.isBlocked === "Y"}
                      onChange={(e) => handleBlockingStatusChange(e)}
                      color="primary"
                    />
                  </Box>
                </Tooltip>
              )}
          </>
        );
      },
    },
    {
      field: "active",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleBlockingStatusChange = async (e) => {
          setAgentlist((prev) =>
            prev.map((data) =>
              data.id === params.row.id
                ? { ...data, isActive: data.isActive === "Y" ? "N" : "Y" }
                : data
            )
          );
          setConfirmationActiveOpen(true);
          setChangeBlockStatusOfOrg({
            id: params.row.id,
            isActive: e.target.checked ? "Y" : "N",
          });
        };
        return (
          <>
            {(window.sessionStorage.getItem("user_role_type") === "admin" ||
              window.sessionStorage.getItem("user_role_type") === "user" ||
              (window.sessionStorage.getItem("user_role_type") === "agent" &&
                (window.sessionStorage.getItem("role") === "admin" ||
                  "application_supervisor"))) && (
                <Tooltip title="Temporarily toggle visibility — inactive accounts remain listed but cannot be contacted.">
                  {" "}
                  <Box display="flex" alignItems="center" className="px-2">
                    <Typography>Active</Typography>
                    <Switch
                      sx={{
                        "& .MuiSwitch-track": {
                          // backgroundColor: isToggled ? "white" : "#ccc",
                          transition: "background-color 0.3s",
                          borderRadius: 20,
                        },
                        "& .MuiSwitch-thumb": {
                          width: 24,
                          height: 24,
                          backgroundColor:
                            params.row.isActive === "Y"
                              ? ThemeColor.PURPLE
                              : ThemeColor.BLACK,
                          transition: "transform 0.3s ease",
                          transform:
                            params.row.isActive === "Y"
                              ? "translateX(2px)"
                              : "translateX(0px)",
                        },
                        "& .MuiSwitch-switchBase": {
                          padding: 1,
                          transition: "transform 0.3s",
                          "&.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: ThemeColor.LIGHTPURPLE,
                          },
                        },
                      }}
                      checked={params.row.isActive === "Y"}
                      onChange={(e) => handleBlockingStatusChange(e)}
                      color="primary"
                    />
                  </Box>
                </Tooltip>
              )}
          </>
        );
      },
    },
  ];

  const AgentlistState = useSelector((state) => state.setting?.agent?.data);
  //(AgentlistState, "agent data");

  useEffect(() => {
    // console.log(UniversitylistState?.pagination)
    if (AgentlistState) {
      // const { data, pagination } = AgentlistState;
      // setRows(data);
      setPagination(AgentlistState?.pagination);
    }
  }, [AgentlistState]);

  useEffect(() => {
    dispatch({ type: "GetAgentList", payload: null });
    setTable_load(true);
    let data = {
      page: 1,
      limit: 50,
    };
    reload(data);
  }, []);

  // Someone else (or another screen) added, updated or deleted an agent:
  // reload exactly the view the user is looking at.
  useRealtimeSync(
    "login",
    useCallback(() => {
      setTable_load(true);
      reload(lastQuery("agent", { page: 1, limit: 50 }));
    }, [dispatch])
  );

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    if (isToggled) {
      setAgentlist(
        AgentlistState?.blockedAgents?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } else {
      setAgentlist(
        AgentlistState?.activeAgents?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    }
    // const updatedData = AgentlistState?.activeAgents?.map(
    //   ({ _id, ...rest }) => ({
    //     id: _id,
    //     ...rest,
    //   })
    // );
    // setAgentlist(updatedData);
    setTable_load(false);
  }, [AgentlistState]);

  // Handle toggle change
  const handleStatusChange = async () => {
    const newToggleState = !isToggled;
    if (newToggleState) {
      setAgentlist(
        AgentlistState?.blockedAgents?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } else {
      setAgentlist(
        AgentlistState?.activeAgents?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    }
    setIsToggled(newToggleState);
  };

  const fields = [
    // { label: "Agent ID", value: "agentId", type: "select", option: Agentlist },
    ...(!(window.sessionStorage.getItem("user_role_type") === "agent")
      ? [
        {
          label: "Organization",
          value: "organization",
          type: "select",
          option: Organizationlist,
        },
      ]
      : []),

    {
      label: "Agent Name",
      value: "firstName",
      type: "text",
      // option: Universitylist,
    },
    {
      label: "Email",
      value: "email",
      type: "text",
      // option: Degreelist,
    },
    {
      label: "Roles",
      value: "roles",
      type: "multi-select",
      option: Rolelist,
    },
  ];
  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    try {
      let response = await axios.get(
        basicurl +
        `/api/login/get-all-active-agents?${string.join(
          "&"
        )}&limit=${0}&page=${1}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);
      setPagination(response.data?.pagination);
      if (isToggled) {
        setAgentlist(
          response.data?.blockedAgents?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      } else {
        setAgentlist(
          response.data?.activeAgents?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetAgentAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetAgentAction(data));
  };

  const handleApplyFilters = applyFilters;

  const handleGetBulkTemplate = async () => {
    try {
      const response = await axios.get(
        `${basicurl}/api/login/agent-users/template`,
        {
          responseType: "blob", // 👈 VERY important for binary data like Excel
        }
      );

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a download link and click it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "agent_bulk.xlsx"; // 👈 you can set a dynamic filename
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ width: "100%", height: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={3} md={3} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  {window.sessionStorage.getItem("user_role_type") === "agent"
                    ? "Member List"
                    : "Agent List"}
                </Typography>
              </div>
            </Grid>
            <Grid item lg={9} md={9} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>
                {window.sessionStorage.getItem("user_role_type") !== "agent" && (
                  <OutlineCustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    onClick={() =>
                      handleExport(
                        selectionModel,
                        "Agent",
                        Agentlist,
                        "isActive",
                        visibleColumns
                      )
                    }
                  >
                    Export
                  </OutlineCustomButton>
                )}
                <Box
                  display="flex"
                  sx={{
                    border: `2px solid ${ThemeColor.GREY}`,
                    borderRadius: 25,
                    px: 2,
                    py: 0.5,
                  }}
                  alignItems="center"
                >
                  <Typography>Blocked</Typography>
                  <Switch
                    sx={{
                      "& .MuiSwitch-track": {
                        transition: "background-color 0.3s",
                        borderRadius: 20,
                      },
                      "& .MuiSwitch-thumb": {
                        width: 24,
                        height: 24,
                        backgroundColor: isToggled
                          ? ThemeColor.PURPLE
                          : ThemeColor.BLACK,
                        transition: "transform 0.3s ease",
                        transform: isToggled
                          ? "translateX(2px)"
                          : "translateX(0px)",
                      },
                      "& .MuiSwitch-switchBase": {
                        padding: 1,
                        transition: "transform 0.3s",
                        "&.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: ThemeColor.LIGHTPURPLE,
                        },
                      },
                    }}
                    checked={isToggled ? true : false}
                    onChange={handleStatusChange}
                    color="primary"
                  />
                </Box>
                {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  window.sessionStorage.getItem("user_role_type") === "user") && (
                  <>
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.YELLOW}
                      color={ThemeColor.WHITE}
                      onClick={handleClick}
                    >
                      Bulk Update
                    </CustomButton>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={openbulk}
                      onClose={handleBulkClose}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <MenuItem onClick={handleGetBulkTemplate}>
                        Download Template
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setBulkModal(!BulkModal);
                        }}
                      >
                        Upload Data (Bulk)
                      </MenuItem>
                    </Menu>
                  </>
                )}
                <CustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  color={ThemeColor.WHITE}
                  onClick={() => navigate("/CAE/AddAgent")}
                >
                  {window.sessionStorage.getItem("user_role_type") === "agent"
                    ? "Add Member"
                    : "Add Agent"}
                </CustomButton>
              </Box>
            </Grid>
          </Grid>
          <FilterComponent
            open={isFilterOpen}
            onClose={() => setFilterOpen(false)}
            onApply={handleApplyFilters}
            initialFilters={activeFilters}
            fields={fields}
          />

          <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={Agentlist ? Agentlist : []}
              columns={columns}
              loading={table_load}
              minTableWidth="100%"
              onSelectionChange={(newSelection) => {
                // console.log(newSelection)
                setSelectionModel(newSelection);
              }}
              getRowClassName={(params) =>
                params.row.isActive === "Y" ? "row-white" : "row-dull"
              }
              onVisibleColumnsChange={handleVisibleColumnsChange}
            />
          </div>

          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />

          <BulkUploadModal
            open={BulkModal}
            handleClose={() => {
              setBulkModal(!BulkModal);
            }}
            url={"api/login/agent-users/bulk-upload"}
            action={() => {
              let data = {
                limit: limit,
                page: 1,
              };
              reload(data);
            }}
          />

          <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setAgentlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isBlocked:
                        changeBlockStatusOfOrg.isBlocked === "Y" ? "N" : "Y",
                    }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditAgentBlockedStatusService(
                  changeBlockStatusOfOrg,
                  { isBlocked: changeBlockStatusOfOrg.isBlocked }
                );

                if (res.status === 200) {
                  let data = {
                    limit: 25,
                    page: 1,
                  };
                  reload(data);
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={"Want to change the blocking status?"}
          />

          <ConfirmationModal
            msg="Updated "
            btnName="Update"
            handleConfirmationClose={() => {
              setAgentlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isActive:
                        changeBlockStatusOfOrg.isActive === "Y" ? "N" : "Y",
                    }
                    : data
                )
              );
              setConfirmationActiveOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditAgentBlockedStatusService(
                  changeBlockStatusOfOrg,
                  { isActive: changeBlockStatusOfOrg.isActive }
                );
                console.log(res);

                if (res.status === 200) {
                  reload();
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationactiveopen}
            message={"Want to change the active status?"}
          />

          <ConfirmationModal
            msg="Password Reset"
            btnName="Reset"
            handleConfirmationClose={() => {
              setResetPasswordConfirmationOpen(false);
              setResetPasswordRow(null);
            }}
            deletefunction={async () => {
              try {
                const res = await ResetUserPasswordService(
                  resetPasswordRow?.id
                );

                if (res.status === 200) {
                  dispatch(
                    showSnackbar(
                      res.data?.message ||
                        "A new password has been sent to the registered email",
                      "success"
                    )
                  );
                  return res;
                } else {
                  return Promise.reject("Unexpected response status");
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={resetPasswordConfirmationOpen}
            message={`Reset the password for ${
              resetPasswordRow?.email || "this agent"
            }? A new random password will be generated and emailed to them.`}
          />
        </>
      )}
    </div>
  );
};

function Agentlist() {
  const dispatch = useDispatch();

  const handleSearch = (searchValue) => {
    console.log(searchValue);
    let data = {
      page: 1,
      limit: 50,
      search: searchValue,
    };

    dispatch(GetAgentAction(data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<AgentlistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default Agentlist;
